import { render } from "./Distributor-add.vue?vue&type=template&id=13c80f11"
import script from "./Distributor-add.vue?vue&type=script&lang=js"
export * from "./Distributor-add.vue?vue&type=script&lang=js"

import "./Distributor-add.vue?vue&type=style&index=0&id=13c80f11&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__